<!--
  404 — v2.14.4 restyle.
  Layout: hero centrato con card floating, blob decorativi in background,
  illustration warehouse-themed + 404 gradient + CTA.
  Tutti i colori tramite design token — dark mode ready.
-->

<section class="nf-page" role="main" aria-labelledby="nf-title">

  <!-- Blob decorativi background (puramente estetici, aria-hidden). -->
  <div class="nf-blobs" aria-hidden="true">
    <span class="nf-blob nf-blob--a"></span>
    <span class="nf-blob nf-blob--b"></span>
    <span class="nf-blob nf-blob--c"></span>
  </div>

  <div class="nf-card">

    <!-- Illustration: scatola/pacco magazzino con etichetta "?". -->
    <div class="nf-illustration" aria-hidden="true">
      <svg viewBox="0 0 200 200" class="nf-box" xmlns="http://www.w3.org/2000/svg">
        <!-- Piano d'appoggio -->
        <ellipse cx="100" cy="175" rx="70" ry="8" class="nf-box__shadow" />

        <!-- Corpo scatola (isometrica semplificata) -->
        <path d="M 40 80 L 100 60 L 160 80 L 160 150 L 100 170 L 40 150 Z" class="nf-box__body" />
        <path d="M 40 80 L 100 100 L 160 80" class="nf-box__lid" />
        <path d="M 100 100 L 100 170" class="nf-box__edge" />

        <!-- Etichetta con "?" -->
        <rect x="72" y="115" width="56" height="32" rx="4" class="nf-box__label" />
        <text x="100" y="140" text-anchor="middle" class="nf-box__question">?</text>

        <!-- Sparks decorative -->
        <circle cx="30" cy="50" r="3" class="nf-spark nf-spark--1" />
        <circle cx="170" cy="45" r="4" class="nf-spark nf-spark--2" />
        <circle cx="180" cy="120" r="2.5" class="nf-spark nf-spark--3" />
      </svg>
    </div>

    <!-- Numero 404 con stagger animation -->
    <div class="nf-code" aria-hidden="true">
      <span class="nf-digit nf-digit--1">4</span>
      <span class="nf-digit nf-digit--2">0</span>
      <span class="nf-digit nf-digit--3">4</span>
    </div>

    <h1 id="nf-title" class="nf-title">Pagina non trovata</h1>

    <p class="nf-subtitle">
      La pagina che stai cercando è stata spostata, rimossa o non è
      mai esistita. Nessun ordine, prodotto o borderò è andato perso —
      solo un URL sbagliato.
    </p>

    @if (attemptedUrl && attemptedUrl !== '/') {
      <p class="nf-url">
        <span class="nf-url__label">Indirizzo richiesto:</span>
        <code class="nf-url__value">{{ attemptedUrl }}</code>
      </p>
    }

    <div class="nf-actions">
      <button
        type="button"
        class="nf-btn nf-btn--primary"
        (click)="goHome()">
        <span class="nf-btn__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12l9-9 9 9" />
            <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10" />
          </svg>
        </span>
        Torna alla dashboard
      </button>

      <button
        type="button"
        class="nf-btn nf-btn--secondary"
        (click)="goBack()">
        <span class="nf-btn__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
               stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
          </svg>
        </span>
        Vai indietro
      </button>
    </div>

  </div>

</section>
